import router from '@/backend/router/index'

function h5router() {
  let whiteList = ['evaluate', 'status', 'evaluates']
  let routerUrl = router.history._startLocation
  if (!routerUrl) return true
  let index = routerUrl.lastIndexOf('/')
  let symbol = routerUrl.indexOf('?')
  let routerval
  if (symbol !== -1) {
    routerval = routerUrl.slice(index + 1, symbol)
  } else {
    routerval = routerUrl.slice(index + 1)
  }
  return whiteList.indexOf(routerval) === -1
}

// 修改页面tab栏标题
if (!h5router()) {
  document.title = '服务评价'
}

export default h5router
